<template>
  <div class="home">
    <div class="section section--home">
      <section class="highlight">
        <div class="container">
            <div class="col-md-5 mx-auto">
              <div class="content">
                <h2>{{ $t('employee_home.title') }}</h2>
                <a class="icon_play" @click="openModal(0)"><img src="../assets/img/home/icons/icon_play.svg" alt="Play video"></a>
              </div>
            </div>
          </div>
          <a @click="anchor('work')" class="link_more link_anchor">
            {{ $t('employee_home.more') }}
            <img class="icon_arrow" src="../assets/img/home/icons/icon_arrow.svg">
        </a>
      </section>

      <section id="work" class="section-a">
        <div class="container">
          <div class="col-md-10 offset-md-1">
            <h2 class="title_section">{{ $t('employee_home.dream.title') }}</h2>
            <p class="text_section">{{ $t('employee_home.dream.text') }}</p>
            <div class="img-wrap">
              <img src="../assets/img/home/img_dwcr.png" alt="">
              <a class="icon_play" @click="openModal(1)">
                <img src="../assets/img/home/icons/icon_play.svg" alt="Play video">
              </a>
            </div>
          </div>
          <div class="col-md-10 offset-md-1">
            <blockquote>
              {{ $t('employee_home.dream.testimonial') }}
            </blockquote>
          </div>
          <div class="col">
            <h3>{{ $t('employee_home.numbers.title') }}</h3>
            <div class="numbers row">
              <div class="item_numbers col-md-3">
                <img class="icon_numbers" src="../assets/img/home/icons/icon_employees.svg">
                <span>+700</span>
                {{ $t('employee_home.numbers.ebankers') }}
              </div>
              <div class="item_numbers col-md-3">
                <img class="icon_numbers" src="../assets/img/home/icons/icon_nationality.svg">
                <span>15</span>
                {{ $t('employee_home.numbers.nationalities') }}
              </div>
              <div class="item_numbers col-md-3">
                <img class="icon_numbers" src="../assets/img/home/icons/icon_merchants.svg">
                <span>1000</span>
                {{ $t('employee_home.numbers.merchants') }}
              </div>
              <div class="item_numbers col-md-3">
                <img class="icon_numbers" src="../assets/img/home/icons/icon_end-user.svg">
                <span>50</span>
                {{ $t('employee_home.numbers.end_users') }}
              </div>
            </div>
          </div>
          <div class="col text-center">
            <a class="button button--blue button--rounded link_anchor" href="https://boards.greenhouse.io/ebanx" target="_blank">{{ $t('employee_home.button_copy') }}</a>
          </div>
        </div>
      </section>

      <section id="culture" class="section-b">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none" fill="#ffffff">
          <polygon points="100 0 100 10 0 10" />
        </svg>
        <div class="container">
          <div class="col">
            <div class="row">
              <div class="col-md-4 offset-md-1">
                <h2 class="title_section">{{ $t('employee_home.culture.title') }}</h2>
                <p class="text_section">{{ $t('employee_home.culture.text') }}</p>
              </div>
              <div class="col-md-5 offset-md-1">
                <div class="row">
                  <div class="img-wrap">
                    <img src="../assets/img/home/img_ocov.png">
                    <a class="icon_play" @click="openModal(2)">
                      <img src="../assets/img/home/icons/icon_play.svg" alt="Play video">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="culture-values row">
              <div class="item_culture-values col-md-3">
                <img class="icon_culture-values" src="../assets/img/home/icons/icon_star.svg">
                <strong>{{ $t('employee_home.values.dream_big.title') }}</strong>
                <p>{{ $t('employee_home.values.dream_big.text') }}</p>
              </div>
              <div class="item_culture-values col-md-3 offset-md-1">
                <img class="icon_culture-values" src="../assets/img/home/icons/icon_target.svg">
                <strong>{{ $t('employee_home.values.results.title') }}</strong>
                <p>{{ $t('employee_home.values.results.text') }}</p>
              </div>
              <div class="item_culture-values col-md-3 offset-md-1">
                <img class="icon_culture-values" src="../assets/img/home/icons/icon_lightning.svg">
                <strong>{{ $t('employee_home.values.hard_work.title') }}</strong>
                <p>{{ $t('employee_home.values.hard_work.text') }}</p>
              </div>
              <div class="item_culture-values col-md-3 offset-md-2">
                <img class="icon_culture-values" src="../assets/img/home/icons/icon_binoculars.svg">
                <strong>{{ $t('employee_home.values.beyond.title') }}</strong>
                <p>{{ $t('employee_home.values.beyond.text') }}</p>
              </div>
              <div class="item_culture-values col-md-3 offset-md-1">
                <img class="icon_culture-values" src="../assets/img/home/icons/icon_handshake.svg">
                <strong>{{ $t('employee_home.values.tamojunto.title') }}</strong>
                <p>{{ $t('employee_home.values.tamojunto.text') }}</p>
              </div>
            </div>
          </div>
          <div class="col text-center">
            <a class="button button--blue button--rounded--blue button--rounded link_anchor" href="https://boards.greenhouse.io/ebanx" target="_blank">{{ $t('employee_home.button_copy') }}</a>
          </div>
        </div>
      </section>

      <section class="section-slideshow">
        <div class="slideshow">
            <div :style="`background-image: url(${getImage('img_slide-1')})`">
              <legend>{{ $t('employee_home.carousel.circus') }}</legend>
            </div>
            <div :style="`background-image: url(${getImage('img_slide-2')})`">
              <legend>{{ $t('employee_home.carousel.festival') }}</legend>
            </div>
            <div :style="`background-image: url(${getImage('img_slide-3')})`">
              <legend>{{ $t('employee_home.carousel.meetups') }}</legend>
            </div>
            <div :style="`background-image: url(${getImage('img_slide-4')})`">
              <legend>{{ $t('employee_home.carousel.athletes') }}</legend>
            </div>
            <div :style="`background-image: url(${getImage('img_slide-5')})`">
              <legend>{{ $t('employee_home.carousel.summit') }}</legend>
            </div>
        </div>
      </section>

      <section id="community" class="section-c">
        <div class="container">
          <div class="col">
            <div class="row">
              <div class="col-md-4 offset-md-1">
                <h2 class="title_section">{{ $t('employee_home.community.title') }}</h2>
                <p class="text_section">{{ $t('employee_home.community.text_1st') }}</p>
                <p class="text_section">{{ $t('employee_home.community.text_2nd') }}</p>
                <p class="text_section">{{ $t('employee_home.community.text_3rd') }}</p>
                <p class="text_section" v-html="$t('employee_home.community.text_4th')"></p>
              </div>
              <div class="col-md-5 offset-md-1">
                <div class="row">
                  <div class="img-wrap">
                    <img src="../assets/img/home/img_yogfvwic.png" alt="">
                    <a class="icon_play" @click="openModal(3)">
                      <img src="../assets/img/home/icons/icon_play.svg" alt="Play video">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col text-center">
            <a class="button button--blue button--rounded link_anchor" href="https://boards.greenhouse.io/ebanx" target="_blank">{{ $t('employee_home.button_copy') }}</a>
          </div>
        </div>
      </section>

      <section class="section-d">
        <img class="icon_ilc" src="../assets/img/home/img_ilc.svg" alt="Eu Amo Curitiba">
      </section>

      <section class="section-e">
        <div class="container">
          <div class="col">
            <div class="row">
              <div class="col-md-4 offset-md-1">
                <h2 class="title_section">{{ $t('employee_home.curitiba.title') }}</h2>
                <p class="text_section">{{ $t('employee_home.curitiba.text_1st') }}</p>
                <p class="text_section" v-html="$t('employee_home.curitiba.text_2nd')"></p>
              </div>
              <div class="col-md-6 offset-md-1">
                <div class="row">
                  <div class="img-wrap">
                    <img src="../assets/img/home/img_wc.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <InstagramFeed />
    </div>

    <Modal v-if="isModalActive" :isActive="isModalActive" :videoURL="videoURL" @closeModal="closeModal()" />
  </div>
</template>

<script>
import scrollElement from "@/utils/scroll";

import Modal from "@/components/layout/Modal";
import InstagramFeed from "@/components/sections/InstagramFeed";
import OpeningsSearch from "@/components/sections/OpeningsSearch";

export default {
  name: "Home",
  components: {
    Modal,
    InstagramFeed,
    OpeningsSearch
  },
  data() {
    return {
      modalActive: false,
      activeVideo: ""
    };
  },
  created() {
    // reset search
    this.$store.dispatch("search/currentSearchTerm", "");

    // reset current opening
    this.$store.dispatch("openings/currentOpeningId", "");

    // reset current team
    this.$store.dispatch("teams/currentTeam", "");

    this.createSlickCarousel();
  },
  methods: {
    viewOpeningTeam(opening) {
      this.$store.dispatch("teams/currentTeam", opening.team);
      this.$router.push({ name: "jobs" });
    },

    getImage(source) {
      let images = require.context("../assets/img/home", false, /\.jpg$/);

      return images("./" + source + ".jpg");
    },

    createSlickCarousel() {
      document.querySelectorAll(".lazy-loaded-style").forEach(item => item.remove());
      document.querySelectorAll(".lazy-loaded-script").forEach(item => item.remove());

      const styles = ["https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css"];

      for (const style of styles) {
        const tag = document.createElement("link");
        tag.type = "text/css";
        tag.rel = "stylesheet";
        tag.href = style;
        tag.classList.add("lazy-loaded-style");

        document.head.append(tag);
      }

      const jquery = document.createElement("script");
      jquery.type = "text/javascript";
      jquery.async = true;
      jquery.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js";
      jquery.classList.add("lazy-loaded-script");

      jquery.onload = () => {
        const slick = document.createElement("script");
        slick.type = "text/javascript";
        slick.async = true;
        slick.src = "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js";
        slick.classList.add("lazy-loaded-script");

        slick.onload = () => {
          // eslint-disable-next-line
          $(".slideshow").slick({
            arrows: true
          });
        };

        document.body.append(slick);
      };

      document.body.append(jquery);
    },

    anchor(to) {
      this.scroll(document.getElementById(to));
    },

    scroll(to) {
      scrollElement(to, 1000, "easeInOutQuad");
    },

    openModal(index) {
      const videos = ["325941977", "331011668", "331012526", "331012858"];

      this.$data.modalActive = true;
      this.$data.activeVideo = videos[index];
    },

    closeModal() {
      this.$data.modalActive = false;
    }
  },
  computed: {
    isModalActive() {
      return this.$data.modalActive;
    },

    videoURL() {
      return this.$data.activeVideo;
    }
  },
  metaInfo: {
    title: "EBANX - Carreiras",
    titleTemplate: null
  }
};
</script>
